module.exports = __webpack_public_path__ + "static/img_1577-916dce97f2601613fb1b95e2492772a3.webp";